<div data-content="fou" class="take-action-tab active">
    <div class="omne-card doc_inbox without-consultant-details">
       <div class="inbox-header col-lg-12 pd-0 d-flex flex-wrap justify-content-between pdy-2">
          <div class="col-lg-3 d-flex align-items-center">
             <h4 class="pd-0 mg-0">Inbox</h4>
          </div>
       </div>
       <div class="clearfix clear-fix"></div>
       <div class="table_wrap inbox-table-main accordion pd-3 table-respo" id="accordion211">
          <div class="custom_table_head">
             <div class="custom_tr row accordion-group">
                <div class="custom_th colw-2">&nbsp;</div>
                <div class="custom_th colw-16">Received Date</div>
                <div class="custom_th colw-25">Subject</div>
                <div class="custom_th colw-19 text-left">Client Name</div>
                <div class="custom_th colw-13 text-left">Start Date (Estimated)</div>
                <div class="custom_th colw-13 text-left">From</div>
                <div class="custom_th colw-4">&nbsp;</div>
                <div class="custom_th colw-4">&nbsp;</div>
                <div class="custom_th colw-4">&nbsp;</div>
             </div>
          </div>
          <div class="accordion-group custom_tr" *ngFor="let mainitem of PackageList">
             <div class="accordion-heading">
                <div class="accordion-toggle custom_tr row collapsed">
                   <div class="custom_td colw-2 pdx-2">
                      <a data-toggle="collapse" data-parent="#accordion211"  href="#collapse{{mainitem.emailLogId}}"
                      (click)="ViewVendorConInformationDocuments(mainitem.task_Id,mainitem.emailLogId,mainitem.EmailId)"
                         class="collapsed plus-toggle"  data-tooltip="Click to expand collapse" data-tooltip-location="bottom">&nbsp;</a>
                   </div>
                   <div class="custom_td colw-16 pdl-2">{{mainitem.sentDate}}</div>
                   <div class="custom_td colw-25">
                      {{mainitem.envelope_Name}}
                   </div>
                   <div class="custom_td colw-19 text-left">{{mainitem.clientName}}</div>
                   <div class="custom_td colw-13 text-left">{{mainitem.esd}}</div>
                   <div class="custom_td colw-13 text-left">{{mainitem.sentBy}}</div>
                   <div class="custom_td colw-4">
                      <div class="table_actions">
                         <span class="modal_open" data-modalName="emailWrap{{mainitem.emailLogId}}"  data-tooltip="View Email" data-tooltip-location="bottom"><img src="../assets/images/icons/ic-mail-action.svg"
                               alt="ic-mail" (click)="emailWrapPopup(mainitem.emailLogId)" data-tooltip="View Email" data-tooltip-location="bottom"/></span>
                      </div>
                      <div class="custom_modal"  [ngClass]="emailWrapStyle[mainitem.emailLogId]" id="emailWrap{{mainitem.emailLogId}}">
                        <div class="custom_modal_wrap">
                          <div class="custom_modal_header">
                            <h5 class="modal-title">Email Message</h5>
                            <button class="close">
                              <span><img src="../assets/images/icons/ic-close.svg" alt="ic-close" (click)="emailWrapPopup(mainitem.emailLogId)"/></span>
                            </button>
                          </div>
                          <div class="custom_modal_body">
                            <div class="email_ttile d-flex align-items-center">
                              <p>{{mainitem.subject}}</p>                              
                            </div>
                            <div class="email_det">
                              <div class="row">
                                <div class="col-sm-6 mail_details">
                                  <table>
                                    <tr>
                                      <td><b>From : &nbsp; </b></td>
                                      <td>{{mainitem.mailFrom}}<br/>{{mainitem.sentDate}}</td>
                                    </tr>
                                    <tr>
                                       <td><b>To : &nbsp; </b></td>
                                       <td>{{mainitem.emailId}}</td>
                                    </tr>
                                    <tr>
                                       <td><b>CC : &nbsp; </b></td>
                                       <td>{{mainitem.mailCC}}</td>
                                    </tr>
                                  </table>
                                </div>
                                
                              </div>
                            </div>
                            <div class="email_subject">
                              <div class="editable" [innerHTML]="mainitem.body" style="text-align: left;" ></div>                                 
                                               
                            </div>
                          </div>
                        </div>
                      </div>
                   </div>
                   <div class="custom_td colw-4">
                      <div class="table_actions">
                         <span class="info-tooltip"><img class="open_popup" src="../assets/images/icons/ic-person-action.svg"
                               alt="ic-mail" />
                            <div class="action_popup withLogo">
                               <div class="col-sm-12 pd-0 pdy-3 d-flex flex-wrap">
                                  <div
                                     class="col-lg-3 text-center float-none d-flex align-items-center justify-content-center bsr-1" data-tooltip="View POC details" data-tooltip-location="bottom">
                                     <img class="" src="../assets/images/ascendion-logo-white.svg" alt=""  data-tooltip="View POC details" data-tooltip-location="bottom">
                                  </div>
                                  <div class="col-lg-9 float-none pdx-0">
                                     <div class="popup_header border-0">
                                        <h6 class="">Onboarding Contact</h6>
                                        <span class="close_popup">
                                          <i class="fa-regular fa-xmark font-18 color-white"></i>
                                        </span>
                                     </div>
                                     <div class="popup_body pdt-0">
                                        <div class="row">
                                           <div class="col-sm-12 d-flex flex-wrap rej_req_info">
                                              <span class="icon-block">
                                                 <img src="../assets/images/icons/ic-person.svg" alt="ic-person">
                                              </span>
                                              <span class="details-block pdt-1 pdl-1">
                                                 <p>{{mainitem.opsExecutive}}</p>
                                                 <small>{{mainitem.opsExecutive_Designation}}</small>
                                              </span>
                                           </div>
                                           <div class="col-sm-12 d-flex flex-wrap rej_req_info">
                                              <span class="icon-block">
                                                 <img src="../assets/images/icons/ic-mail.svg" alt="ic-person">
                                              </span>
                                              <span class="details-block pdt-1 pdl-1">
                                                 <p>
                                                    <a
                                                       href="mailto:{{mainitem.opsExecutiveEmail}}">{{mainitem.opsExecutiveEmail}}</a>
                                                 </p>
                                              </span>
                                           </div>
                                           <div class="col-sm-12 d-flex flex-wrap rej_req_info">
                                              <span class="icon-block">
                                                 <img src="../assets/images/icons/ic-contact.svg" alt="ic-person">
                                              </span>
                                              <span class="details-block pdt-1 pdl-1">
                                                 <p>
                                                    <a href="tel:{{mainitem.opsExecutive_Phone}}">{{mainitem.opsExecutive_Phone}}</a>
                                                 </p>
                                              </span>
                                           </div>
                                        </div>
                                     </div>
                                  </div>
                               </div>
                            </div>
                         </span>
                      </div>
                   </div>
                   <div class="custom_td colw-4">
                      <div class="table_actions" style="cursor: pointer;"
                      data-tooltip="Pin Email" data-tooltip-location="bottom">
                        <span class="modal_open" data-modalName="emailWrap" *ngIf="!mainitem.isPin">
                          <img  src="../assets/images/icons/ic-pin-unactive.svg" alt="ic-mail" 
                          (click)="PinVendorConsselectedDocs(mainitem.task_Id,mainitem.envMstrID,mainitem.emailLogId,mainitem.doc_type)"  data-tooltip="Pin Email" data-tooltip-location="bottom"/>
                       </span>

                       <span class="modal_open" data-modalName="emailWrap" *ngIf="mainitem.isPin">
                          <img  src="../assets/images/icons/ic-pin-active.svg" alt="ic-mail" 
                          (click)="UnPinVendorConsselectedDocs(mainitem.task_Id,mainitem.envMstrID,mainitem.emailLogId,mainitem.pinID,mainitem.doc_type)" data-tooltip="Pin Email" data-tooltip-location="bottom"/>
                       </span>
                     </div>
                   </div>
                </div>
             </div>
            <app-view-vendor-child-cons-information-docs [item]="mainitem.emailLogId" [itemtaskid]="mainitem.task_Id"></app-view-vendor-child-cons-information-docs>
          </div>
        
          
       </div>
    </div>
    <div class="clear-fix clearfix"></div>
 </div>